export default "__VITE_ASSET__BBnW8SSV__"